(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/utils/react-help-utils/assets/javascripts/create-router.js') >= 0) return;  svs.modules.push('/components/utils/react-help-utils/assets/javascripts/create-router.js');
"use strict";



(function (svs) {
  var _React = React,
    isValidElement = _React.isValidElement;
  var _ReactRouterDOM = ReactRouterDOM,
    BrowserRouter = _ReactRouterDOM.BrowserRouter,
    Switch = _ReactRouterDOM.Switch,
    Route = _ReactRouterDOM.Route,
    Router = _ReactRouterDOM.Router;
  var _svs$core$data = svs.core.data,
    baseUrl = _svs$core$data.baseUrl,
    routes = _svs$core$data.routes;
  var Async = svs.utils.reactHelpUtils.components.Async;
  var isPromise = function isPromise(promise) {
    return promise && typeof promise.then === 'function';
  }; 

  svs.utils.reactHelpUtils.createRouter = function (routeHandlers) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var historyReference = arguments.length > 2 ? arguments[2] : undefined;
    if (options.useHistory && window.History) {
      var history = window.History.createBrowserHistory({
        basename: baseUrl
      });
      historyReference.history = history;
      return React.createElement(Router, {
        history: history
      }, renderRoutes(routeHandlers, options));
    }
    return React.createElement(BrowserRouter, {
      basename: baseUrl
    }, renderRoutes(routeHandlers, options));
  };
  var renderRoutes = function renderRoutes(routeHandlers, options) {
    return React.createElement("div", null, React.createElement(Switch, null, Object.keys(routes).map(function (path) {
      var clientAction = routes[path];
      var routeHandler = routeHandlers[clientAction];
      if (!routeHandler) {
        throw new Error("".concat(path, " does not have a matching handler for client action: ").concat(clientAction));
      }
      var routeComponent = createRouteComponent(routeHandler);
      if (options.enhance) {
        routeComponent = options.enhance(routeComponent);
      }
      return React.createElement(Route, {
        component: routeComponent,
        exact: true,
        key: path,
        path: path
      });
    })), options.catchAll ? React.createElement(Route, {
      exact: true
    }, options.catchAll) : null);
  };
  function createRouteComponent(routeHandler) {
    return function (props) {
      var elementOrPromise = routeHandler(props);
      if (isValidElement(elementOrPromise)) {
        return elementOrPromise;
      }
      if (isPromise(elementOrPromise)) {
        return React.createElement(Async, {
          promise: elementOrPromise
        });
      }
      throw new Error('Route handler must return a valid react element or a promise that resolves with one');
    };
  }
})(svs);

 })(window);